


















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import ProductDetail from '@/components/ProductDetail.vue'
import ProductAddDetail from '@/components/ProductAddDetail.vue'
import SearchFilter from '@/components/Utilities/SearchFilter.vue'
import LeftClickOptionMenu from "@/components/Utilities/LeftClickOptionMenu.vue";

@Component({

    components: {
        ProductDetail,
        ProductAddDetail,
        SearchFilter,
        LeftClickOptionMenu
    }
})
export default class ProductSearch extends Vue {

    @Prop({ default: true })
    public showDetail: boolean;

    @Prop({ default: false })
    public multiSelect: boolean;

    @Prop({ default: false })
    public linkSearch: boolean;
    empty: any; // aggiunto per eliminare l'errore visualizzato da visual studio code, da verificare se c'è un metodo migliore
    productsSelected: any[] = [];
    showDetailInternal: boolean = false;
    idProductDetail: any = null;
    produtCodeSelected: string = null;
    general: any = {};
    freeText = null;
    showLoading: boolean = false;
    ready: boolean = false;
    firstSearch: boolean = false;
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;
    selectedLanguage: any = null;
    selectedLanguageChange: boolean = false;
    showChage: boolean = false;
    optionsLanguage: any = new Array();
    selectedCulture: any = null;
    countryAuthorityList: any[] = null;
    showInfo: boolean = false;
    // advanced search
    advCode: string = null;
    advDescription: string = null;
    advLiv0: string = null;
    advLiv1: string = null;
    advLiv2: string = null;
    advLiv3: string = null;
    advLiv4: string = null;
    advLiv5: string = null;
    advLiv6: string = null;

    optionsLiv0: any = new Array();
    optionsLiv1: any = new Array();
    optionsLiv2: any = new Array();
    optionsLiv3: any = new Array();
    optionsLiv4: any = new Array();
    optionsLiv5: any = new Array();
    optionsLiv6: any = new Array();

    //pacchetto per menu tasto destro su dettaglio entita'
    leftClickOptionMenuUrl: string = "/products/";
    leftClickOptionMenuUrlArgument: string = "code";
    handleClick (event, item) {
        (this.$refs.leftClickOptions as LeftClickOptionMenu).handleClick(event, item);
    }

    filterSelected: boolean = false;

    checkFilterParameter(){
        if(this.AdvancedSearchFilled)
            this.filterSelected = true;
        else
            this.filterSelected = false;
    }

    // end advanced search
    FilterDocuments(items: any[], documentType: string): any[] {
        if (items) {
            return items.filter(p => p.documentType.code == documentType);
        }
        return [];

    }
    get ProductTitle(): string {
        return `${ this.$t('PRODUCT.PRODUCT_CODE') as string + ": " + this.produtCodeSelected}`;
    }
    CheckIsNullOrEmpty(text: string) {
        if (text == null) return true;
        if (text == '') return true;
        return false;
    }
    get AdvancedSearchFilled(): boolean {
        
        if (!this.CheckIsNullOrEmpty(this.advCode)) return true;
        if (!this.CheckIsNullOrEmpty(this.advDescription)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv0)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv1)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv2)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv3)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv4)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv5)) return true;
        if (!this.CheckIsNullOrEmpty(this.advLiv6)) return true;
        
        return false;
    }
    async hierarchyList(liv) {

        let outputData = new Array();
        let apiUrl = General.GetApiUrl('/api/Product/GetHierarchyList?liv='+liv);
        let result = await axios({
            method: 'get',
            url: apiUrl,
            responseType: 'json',
            withCredentials: true
        });

        outputData.push({
            value: null,
            text: ''
        });
        
        result.data.forEach(function (item: any) {
            outputData.push({
                value: item.description,
                text: item.description
            });
        });
        
        return outputData;
    
    }
    resetFilters() {
        this.advCode = null;
        this.advDescription = null;
        this.advLiv0 = null;
        this.advLiv1 = null;
        this.advLiv2 = null;
        this.advLiv3 = null;
        this.advLiv4 = null;
        this.advLiv5 = null;
        this.advLiv6 = null;
        this.filterSelected = false;
    }
    async mounted() {
        this.ready = true;
        this.showDetailInternal = this.showDetail;
        this.general = General;

        this.optionsLiv0 = await this.hierarchyList(0);
        this.optionsLiv1 = await this.hierarchyList(1);
        this.optionsLiv2 = await this.hierarchyList(2);
        this.optionsLiv3 = await this.hierarchyList(3);
        this.optionsLiv4 = await this.hierarchyList(4);
        this.optionsLiv5 = await this.hierarchyList(5);
        this.optionsLiv6 = await this.hierarchyList(6);

        if (this.$route.params.id) {
            let app: any = this;
            let productCode: string = this.$route.params.id;
            let promise = this.getProductId(productCode);
            promise.then(function (val) {
                let product: any = {
                    code: productCode,
                    idProduct: val
                };
                app.openProduct(product, true);

            });
        }

        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if (modalId=='product-detail-modal'){
                this.$router.push({name:'Products'});  
            }
            
        })
        
    }

    postAddingProduct({idProduct, code}) {
        this.$router.push('/products/' + code);
        this.idProductDetail = idProduct;
        this.produtCodeSelected = code;
        this.$bvModal.show('product-detail-modal');       
    }

    @Watch('selectedLanguage')
    selectedChanger() {
        this.selectedLanguageChange = true;

    }

    async getProductId(productCode: string) {
        let idProduct: string = null;

        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/product/GetProductByCode?productCode=' + productCode),
                responseType: 'json',
                withCredentials: true
            });
            idProduct = response.data;
        } catch (error) {
            General.HandleError(error, this);
            
        }

        return idProduct;
    }
    openProduct(product: any, forceOpen: boolean) {
        if (!forceOpen) this.$router.push('/products/' + product.code);
        this.idProductDetail = product.idProduct;
        this.produtCodeSelected = product.code;
        this.$bvModal.show('product-detail-modal');
    }

    createProduct() {
        this.$bvModal.show('product-add-detail-modal');
    }

    close() {
        this.$bvModal.hide('product-detail-modal');
    }
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }

    searchFilterSearchEvent(genericSearch: string) {
        if (genericSearch != null) 
            this.freeText = genericSearch
        
        this.searchItems(true)
    }

    searchFilterResertEvent() {
        this.resetFilters()
    }

    async searchProductDo(start: boolean) {

        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {
            
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/product/GetProductsWithFilter'),
                data: {
                    FreeText: this.freeText,
                    Code: this.advCode,
                    Description: this.advDescription,
                    Liv0: this.advLiv0,
                    Liv1: this.advLiv1,
                    Liv2: this.advLiv2,
                    Liv3: this.advLiv3,
                    Liv4: this.advLiv4,
                    Liv5: this.advLiv5,
                    Liv6: this.advLiv6,
                    IdLanguage: null,
                    IdCountry: null,
                    PublicSearch: false,
                    ShowEmptyProducts: false,
                    CurrentPage: this.page

                },
                withCredentials: true,
                responseType: 'json'
            });
           
            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
            if (this.countryAuthorityList != null && this.countryAuthorityList.length > 1) {
                this.showChage = true;
            } else {
                this.showChage = false;
            }
             
            this.firstSearch = true;
            this.page += 1;
            
            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }

    searchItems(start: boolean) {
        let app = this;
        this.searchProductDo(start);
    }
    countrySelectorModal(open: boolean) {
        if (open == true) {
            this.$bvModal.show('country-authority-selector');
        } else {
            this.$bvModal.hide('country-authority-selector');
        }
    }

    checkCountrySelector(start: boolean) {
        this.selectedLanguageChange = false;
        let url: string = '/api/culture/GetCulturesWithFilter?IdLanguage=' + this.selectedLanguage;
        this.countryAuthorityList = null;

        axios({
            method: 'get',
            url: General.GetApiUrl(url),
            withCredentials: true,
            responseType: 'json'
        }).then(({ data }) => {
            if (data.length == 1) {
                this.countryAuthorityList = null;
                this.selectedCulture = data[0];
                this.searchProductDo(start);
            } else {
                this.countryAuthorityList = data;
                this.countrySelectorModal(true);
            }
        })
    }
    countrySelector(culture: any) {
        this.selectedCulture = culture;
        this.countrySelectorModal(false);
        this.searchProductDo(true);
    }
    productsSelectedChange() {
        this.$emit('productsSelectedChange', this.productsSelected);
    }

    canUserManualProcessProduct() {
        return General.CanManualProcessProduct();
    }
}
